// A-020 P2b: Anschrift eines Kunden für Belege – eine Stelle für Kundenfenster (Vorschau) und Beleg-Editor.
// Gegenstück im Server: adresszeilen_drucken/anschrift_teile in backend/module_angebote/routes.py (gleiche Regeln).
// Zeilen: Firma, Zusatzzeilen (adresszeilen, „im Beleg“), Person, Straße, PLZ Ort; Reihenfolge beim Kunden in anschrift_reihenfolge.

export const zeilenSchluessel = (z, i) => (z && z.id) || `z${i}`;

const nachReihenfolge = (teile, reihenfolge) => {
  const bekannt = (reihenfolge || []).filter((k) => teile.some((t) => t.key === k));
  if (!bekannt.length) return teile;
  const ergebnis = bekannt.map((k) => teile.find((t) => t.key === k));
  // neue Zeilen (noch nicht in der Reihenfolge) hinter ihren Vorgänger aus der Standard-Reihenfolge
  teile.forEach((t, i) => {
    if (bekannt.includes(t.key)) return;
    const vor = i > 0 ? ergebnis.indexOf(teile[i - 1]) : -1;
    ergebnis.splice(vor + 1, 0, t);
  });
  return ergebnis;
};

export const anschriftTeile = (k = {}) => {
  const person = (k.vorname || k.nachname) ? `${k.vorname || ""} ${k.nachname || ""}`.trim() : (k.firma ? "" : (k.name || ""));
  let strasse = `${k.strasse || ""} ${k.hausnummer || ""}`.trim();
  let ort = `${k.plz || ""} ${k.ort || ""}`.trim();
  if (!strasse && !ort && k.address) {
    const teile = String(k.address).split(/,\s*|\n/).map((s) => s.trim()).filter(Boolean);
    strasse = teile[0] || ""; ort = teile.slice(1).join(" ");
  }
  const zusatz = (k.adresszeilen || []).map((z, i) => ({ key: zeilenSchluessel(z, i), text: String(z?.text || "").trim(), art: z?.bezeichnung || "Zusatz", drucken: z?.drucken !== false }))
    .filter((z) => z.drucken && z.text);
  const teile = [
    { key: "firma", text: (k.firma || "").trim(), art: "Firma" },
    ...zusatz,
    { key: "person", text: person, art: "Person" },
    { key: "strasse", text: strasse, art: "Straße" },
    { key: "ort", text: ort, art: "PLZ Ort" },
  ].filter((t) => t.text);
  return nachReihenfolge(teile, k.anschrift_reihenfolge);
};

// Kunde hat eigene Zeilen oder eigene Reihenfolge → Anschrift im Beleg zeilenweise
export const anschriftBesonders = (k = {}) =>
  (k.adresszeilen || []).some((z) => z?.drucken !== false && String(z?.text || "").trim()) || (k.anschrift_reihenfolge || []).length > 0;
